<div style="position: relative; z-index: 1">
  <div *ngIf="remainingTime$ | async as remainingTime">
    <div class="session-expiring-style" *ngIf="remainingTime <= 600">
      <div>
        <div style="color: #856404;">
          ⚠ {{ 'notification.sesijos.pratesimas' | translate }} {{ formatTime(remainingTime) }}.
        </div>
        <div style="color: #856404;">
          {{ 'notification.sesijos.pratesimas2' | translate }}
          <span class="bold-underline" (click)="pratestiSesija()">
                {{ 'button.pratesti' | translate }}
              </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="position: relative; z-index: 1">
  <div class="session-expired-style" *ngIf="sessionExpired$ | async">
    <button class="close-button" (click)="closeSessionExpired()">╳</button>
    <div>
      <div style="color: #721C24; margin-right: 30px;">
        ⚠ {{ 'notification.sesija.baigesi' | translate }}
      </div>
      <div style="color: #721C24">
        {{ 'notification.sesija.baigesi2' | translate }}
        <span class="bold-underline" (click)="redirectToGpais()">
              {{ 'button.cia' | translate }}
            </span>
      </div>
    </div>
  </div>
</div>
<div class="toolbar-style">

  <div class="toolbar-left">
    <div class="logo-container">
      <img src="assets/new_am_logo.svg" alt="Logo">
    </div>
    <div class="custom-toolbar-item">GPAIS</div>
  </div>

  <div class="toolbar-right">
    <div class="col-md-2 toolbar-label-style align-right">
      <div class="col toolbar-inner-label">
        <label>
          {{ this.userData?.fullName }}
        </label>
      </div>
    </div>

    <div class="toolbar-icons">
      <div class="language-flag" (click)="toggleLanguage()">
        <img src="assets/lt_flag.png" style="height: 20px; width: 30px" *ngIf="currentLanguage === 'lt'" alt="">
        <img src="assets/en_flag.png" style="height: 20px; width: 30px" *ngIf="currentLanguage === 'en'" alt="">
      </div>
      <div class="sing-out" (click)="redirectToGpais()">
        <kendo-svg-icon [icon]="icons.logout" style="width: 25px; height: 25px;"></kendo-svg-icon>
      </div>
    </div>
  </div>
</div>
<kendo-drawer-container class="drawer-container">
  <kendo-drawer style="height: 100%; position: sticky; border-top-width: 1px"
                #drawer
                [items]="menuItems"
                mode="push"
                [mini]="true"
                [expanded]="true"
                [autoCollapse]="false"
                (select)="onSelect($event)"
  >
  </kendo-drawer>
  <kendo-drawer-content>
    <router-outlet></router-outlet>
  </kendo-drawer-content>
  <kendo-window
    *ngIf="regPerziuraService.perziura$ | async as perziura"
    (close)="regPerziuraService.closePerziura()"
    [minWidth]="250"
    [width]="1200"
    [height]="800"
    themeColor="primary"
    title="{{ 'title.gaminiu.perziura.' + perziura.srautoKodas | translate }}"
  >
    <app-reg-perziura [regPerziura]="perziura"></app-reg-perziura>
  </kendo-window>
  <kendo-window
    *ngIf="ataskPerziuraService.ataskPerziura$ | async as ataskPerziura"
    (close)="ataskPerziuraService.closePerziura()"
    [minWidth]="1400"
    [width]="1400"
    [height]="800"
    themeColor="primary"
    title="{{ 'apskaita.title.ataskaitosPerziura' | translate }}"
  >
    <app-atask-perziura-pilna></app-atask-perziura-pilna>
  </kendo-window>
</kendo-drawer-container>
